// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3b533298","498":"5042c2d3","703":"e4a49951","787":"0811b6b6","839":"6259da81"}[chunkId] + ".chunk.js";
};